import { css } from 'styled-system/css';
import { LogoMark } from '../ui/logo/LogoMark';
import { Container } from './Container';
import { Reveal } from './Reveal';

const columns: { title: string; links: { name: string; href: string }[] }[] = [
  {
    title: 'Product',
    links: [{ name: 'FAQ', href: '/#faq' }],
  },
  {
    title: 'Company',
    links: [{ name: 'About', href: '/about' }],
  },
  {
    title: 'Legal',
    links: [
      { name: 'Privacy', href: '/privacy' },
      { name: 'Terms', href: '/terms' },
      { name: 'Refunds', href: '/refunds' },
    ],
  },
];

export function FooterSection() {
  return (
    <footer
      className={css({
        position: 'relative',
        marginTop: { base: '8', md: '12' },
        backgroundImage:
          'linear-gradient(180deg, color-mix(in srgb, token(colors.bg.surface) 55%, transparent), transparent 28%)',
      })}
    >
      <Container>
        <div
          className={css({
            display: 'grid',
            gridTemplateColumns: { base: '1fr', md: '1.5fr 1fr 1fr 1fr' },
            gap: { base: '10', md: '8' },
            paddingBlock: { base: '14', md: '20' },
          })}
        >
          <Reveal>
            <div
              className={css({
                display: 'flex',
                flexDirection: 'column',
                gap: '4',
                alignItems: 'flex-start',
              })}
            >
              <span
                className={css({
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '2.5',
                  color: 'text.primary',
                })}
              >
                <LogoMark size={22} prism />
                <span
                  className={css({
                    fontFamily: 'display',
                    fontWeight: 'bold',
                    fontSize: 'lg',
                    letterSpacing: 'tight',
                    lineHeight: '1',
                  })}
                >
                  Exis
                </span>
              </span>
              <p
                className={css({
                  fontSize: 'sm',
                  lineHeight: 'relaxed',
                  color: 'text.muted',
                  maxWidth: '32ch',
                })}
              >
                Automate your spreadsheets with AI agents, while reviewing all
                changes.
              </p>
              <span
                className={css({
                  fontFamily: 'mono',
                  fontSize: '2xs',
                  letterSpacing: 'wide',
                  color: 'text.muted',
                })}
              >
                &copy; 2026 Exis Pro Ltd
              </span>
            </div>
          </Reveal>

          {columns.map((column, i) => (
            <Reveal key={column.title} delay={(i + 1) * 80}>
              <nav aria-label={`Footer — ${column.title}`}>
                <h3
                  className={css({
                    textStyle: 'eyebrow',
                    color: 'text.faint',
                  })}
                >
                  {column.title}
                </h3>
                <ul
                  className={css({
                    listStyle: 'none',
                    margin: 0,
                    padding: 0,
                    marginTop: '5',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '3',
                  })}
                >
                  {column.links.map((link) => (
                    <li key={link.name}>
                      <a
                        href={link.href}
                        className={css({
                          fontSize: 'sm',
                          color: 'text.muted',
                          transition: 'color 200ms {easings.out}',
                          _hover: { color: 'text.primary' },
                          _focusVisible: {
                            outline: '2px solid token(colors.border.focus)',
                            outlineOffset: '2px',
                          },
                        })}
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            </Reveal>
          ))}
        </div>
      </Container>

      <div
        aria-hidden="true"
        className={css({
          overflow: 'hidden',
        })}
      >
        <div
          className={css({
            fontFamily: 'display',
            fontWeight: 'bold',
            fontSize: 'clamp(12rem, 38vw, 36rem)',
            lineHeight: '0.8',
            letterSpacing: 'tight',
            textAlign: 'center',
            marginBottom: '-0.18em',
            paddingTop: '4',
            backgroundImage:
              'linear-gradient(180deg, token(colors.text.faint), token(colors.bg.page))',
            backgroundClip: 'text',
            color: 'transparent',
            opacity: 0.6,
            userSelect: 'none',
          })}
        >
          EXIS
        </div>
      </div>
    </footer>
  );
}
